import * as FeathersErrors from '@feathersjs/errors';

function customiseFeathersError(ErrorClass) {
  return class extends ErrorClass {
    constructor(type, payload = {}) {
      super(null, {
        type,
        payload,
      });
    }
  };
}

export const GeneralError = customiseFeathersError(FeathersErrors.GeneralError);
export const BadRequest = customiseFeathersError(FeathersErrors.BadRequest);
export const NotAuthenticated = customiseFeathersError(FeathersErrors.NotAuthenticated);
export const Forbidden = customiseFeathersError(FeathersErrors.Forbidden);
export const MethodNotAllowed = customiseFeathersError(FeathersErrors.MethodNotAllowed);
export const NotFound = customiseFeathersError(FeathersErrors.NotFound);
